import { ChainId } from '@shibaswap/sdk'


export const NETWORK_ICON = {
    [ChainId.MAINNET]: '/images/networks/mainnet-network.jpg',
    [ChainId.ROPSTEN]: '/images/networks/ropsten-network.jpg',
    [ChainId.RINKEBY]: '/images/networks/rinkeby-network.jpg',
    [ChainId.GÖRLI]: '/images/networks/goerli-network.jpg',
    [ChainId.KOVAN]: '/images/networks/kovan-network.jpg',
    [ChainId.FANTOM]: '/images/networks/fantom-network.jpg',
    [ChainId.FANTOM_TESTNET]: '/images/networks/fantom-network.jpg',
    [ChainId.BSC]: '/images/networks/bsc-network.jpg',
    [ChainId.BSC_TESTNET]: '/images/networks/bsc-network.jpg',
    [ChainId.MATIC]: '/images/networks/matic-network.jpg',
    [ChainId.MATIC_TESTNET]: '/images/networks/matic-network.jpg',
    [ChainId.XDAI]: '/images/networks/xdai-network.jpg',
    [ChainId.ARBITRUM]: '/images/networks/arbitrum-network.jpg',
    [ChainId.MOONBASE]: '/images/networks/moonbeam-network.jpg',
    [ChainId.AVALANCHE]: '/images/networks/avalanche-network.jpg',
    [ChainId.FUJI]: '/images/networks/avalanche-network.jpg',
    [ChainId.HECO]: '/images/networks/heco-network.jpg',
    [ChainId.HECO_TESTNET]: '/images/networks/heco-network.jpg',
    [ChainId.HARMONY]: '/images/networks/harmonyone-network.jpg',
    [ChainId.HARMONY_TESTNET]: '/images/networks/harmonyone-network.jpg',
    [ChainId.PUPPYNET]: '/images/networks/shibarium-network.png',
    [ChainId.SHIBARIUM]: '/images/networks/shibarium-network.png',
    [ChainId.SEPOLIA]: '/images/networks/mainnet-network.jpg'
}

export const NETWORK_LABEL: { [chainId in ChainId]?: string } = {
    [ChainId.MAINNET]: 'Ethereum',
    [ChainId.RINKEBY]: 'Rinkeby',
    [ChainId.ROPSTEN]: 'Ropsten',
    [ChainId.GÖRLI]: 'Görli',
    [ChainId.KOVAN]: 'Kovan',
    [ChainId.FANTOM]: 'Fantom',
    [ChainId.FANTOM_TESTNET]: 'Fantom Testnet',
    [ChainId.MATIC]: 'Matic',
    [ChainId.MATIC_TESTNET]: 'Matic Testnet',
    [ChainId.XDAI]: 'xDai',
    [ChainId.BSC]: 'BSC',
    [ChainId.BSC_TESTNET]: 'BSC Testnet',
    [ChainId.MOONBASE]: 'Moonbase',
    [ChainId.AVALANCHE]: 'Avalanche',
    [ChainId.FUJI]: 'Fuji',
    [ChainId.HECO]: 'HECO',
    [ChainId.HECO_TESTNET]: 'HECO Testnet',
    [ChainId.HARMONY]: 'Harmony',
    [ChainId.HARMONY_TESTNET]: 'Harmony Testnet',
    [ChainId.PUPPYNET]: 'PUPPYNET',
    [ChainId.SHIBARIUM]: 'SHIBARIUM',
    [ChainId.SEPOLIA]: 'SEPOLIA'
}
